module.exports = __webpack_public_path__ + "img/normal_multiplier_3.87022090.png";